import { defineStore } from 'pinia'
import type { LoadingType } from '@/types/loading-type'

export const useLoadingStore = defineStore('loading', () => {
  const spinner: LoadingType = 'spinner'

  const state = ref<Record<string, { isLoading: boolean; count: number }>>({
    [spinner]: {
      isLoading: false,
      count: 0
    }
  })

  const isSpinnerLoading = computed(
    (): boolean => !!state.value[spinner]?.isLoading
  )

  const isAreaLoading = computed(() => {
    return Object.entries(state.value).reduce(
      (prev, [key, value]) => {
        if (key !== spinner) {
          prev[key] = value.isLoading
        }

        return prev
      },
      {} as Record<string, boolean>
    )
  })

  const addLoading = (type: string): void => {
    if (!state.value[type]) {
      state.value[type] = { isLoading: false, count: 0 }
    }

    const key = state.value[type]

    if (key) {
      key.isLoading = true
      key.count++
    }
  }

  const closeLoading = (type: string): void => {
    const key = state.value[type]

    if (key) {
      setTimeout(() => {
        if (key.count > 0) {
          key.count--
        }

        if (key.count === 0) {
          key.isLoading = false
        }
      }, 500)
    }
  }

  return {
    isSpinnerLoading,
    isAreaLoading,
    addLoading,
    closeLoading
  }
})
